import React, { Component } from 'react';

import classNames from './../utils/classNames';

const noScrollClassName = 'modal-no-scroll';

class Modal extends Component {
    constructor(props) {
        super(props);

        this.onWrapClick = this.onWrapClick.bind(this);
    }

    onWrapClick() {
        const { onClose } = this.props;
        if (!onClose) {
            return;
        }
        onClose();
    }

    onModalClick(event) {
        event.stopPropagation();
    }

    componentDidMount() {
        document.body.classList.add(noScrollClassName);
    }

    componentWillUnmount() {
        document.body.classList.remove(noScrollClassName);
    }

    render() {
        const { wide, small, children, className } = this.props;
        const containerClassName = classNames('modal-container', { 'modal-wide': wide }, { 'modal-sm': small }, className);
        return (
            <div className="modal-wrap" onClick={this.onWrapClick}>
                <div className={containerClassName} onClick={this.onModalClick}>
                    {children}
                </div>
            </div>
        );
    }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal.js